import Modal from 'react-modal';
import './MenuOptions.css';
import React, {useState} from "react";
import RestorePassword from "../../../Pages/Login/RestorePassword/RestorePassword";
import ChangePassword from "./ChangePassword/ChangePassword";
import {useNavigate} from "react-router-dom";
import axios from "axios";

const MenuOptions = ({isOpen, onRequestClose}) => {

    const navigate = useNavigate();
    // const [isChangeModalOpen, setIsChangeModalOpen] = useState(false);

    let urlName = window.location.pathname;

    const closeMenu = () => {
        onRequestClose(false);
    }

    const changePassword = () => {

    }

    // const openChangeModal = () => {
    //     setIsChangeModalOpen(true);
    // }

    const goToProfile = () => {
        if (urlName==='/profile') {
            closeMenu();
        } else {
            navigate('/profile');
        }
    }

    const goToAccount = () => {
        navigate('/account');
    }

    const logout = () => {

        axios.get(`/api/logout/`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                //     'X-CSRFToken': getCookie('csrftoken'),
                    'Access-Control-Allow-Headers': 'X-CSRFToken'
                }, withCredentials: true
            }
        )
            .then(res => {
                navigate('/login');
            })
            .catch(e => {
                console.log(e);
            })

    }

    // const deleteAccount = () => {
    //
    //     if (window.confirm('Удаление аккаунта приведёт к потере всех данных, связанных с аккаунтом, по истечении 10 дней. Удалить?')) {
    //         axios.get(`/api/del_account/`, {
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     'Access-Control-Allow-Origin': '*',
    //                     'Access-Control-Allow-Headers': 'X-CSRFToken'
    //                 }, withCredentials: true
    //             }
    //         )
    //             .then(res => {
    //                 if (res.status === 200) {
    //                     alert('Профиль успешно удалён');
    //                     navigate('/login', {replace: true});
    //                 }
    //             })
    //             .catch(e => {
    //                 console.log(e);
    //             })
    //     }
    //
    // }

    return (
        <Modal
            isOpen={isOpen}
            // onRequestClose={closeMenu}
            contentLabel="Меню"
            className="menu-modal"
            overlayClassName="modal-overlay-menu"
            appElement={document.getElementById('root')}
        >
            <div className="menu-modal-container">
                <p className={'menu-option'} onClick={() => goToProfile()}>Мои игры</p>
                {/*<p className={'menu-option'}>Дополнительное оборудование</p>*/}
                <p className={'menu-option'} onClick={() => goToAccount()}>Профиль</p>
                <p className={'menu-option delete-acc-button'} onClick={() => logout()}>Выйти</p>
                {/*<p className={'menu-option delete-acc-button'} onClick={() => deleteAccount()}>Удалить профиль</p>*/}
            </div>

            {/*<ChangePassword*/}
            {/*    isOpen={isChangeModalOpen}*/}
            {/*    onRequestClose={setIsChangeModalOpen}*/}
            {/*/>*/}
        </Modal>
    );
}

export default MenuOptions;